export default "__VITE_ASSET__DhqVMvTj__"